import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '@/contexts/LanguageContext';
import { hasConsented, acceptAll, rejectAll, initConsent } from '@/utils/cookieConsent';
import CookiePreferencesModal from '@/components/CookiePreferencesModal';

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);
  const [prefsOpen, setPrefsOpen] = useState(false);
  const { t } = useLanguage();

  useEffect(() => {
    if (!hasConsented()) {
      setVisible(true);
    } else {
      initConsent();
    }
  }, []);

  const handleAcceptAll = () => {
    acceptAll();
    setVisible(false);
  };

  const handleRejectAll = () => {
    rejectAll();
    setVisible(false);
  };

  const handlePrefsClose = (saved) => {
    setPrefsOpen(false);
    if (saved) setVisible(false);
  };

  // Reopen from footer link
  useEffect(() => {
    const handler = () => setPrefsOpen(true);
    window.addEventListener('openCookiePreferences', handler);
    return () => window.removeEventListener('openCookiePreferences', handler);
  }, []);

  if (!visible && !prefsOpen) return null;

  return (
    <>
      {visible && (
        <div
          data-testid="cookie-banner"
          className="fixed bottom-0 left-0 right-0 z-[60] bg-[#F9F8F6]/95 backdrop-blur-md border-t border-[#333333]/10 px-6 md:px-12 py-6"
        >
          <div className="max-w-4xl mx-auto flex flex-col gap-4">
            <p className="text-sm font-light text-[#333333]/90 max-w-2xl">
              {t.cookies.bannerText}{' '}
              <Link
                to="/privacidade"
                className="text-[#35589B] underline hover:text-[#2C4A85]"
                data-testid="cookie-policy-link"
              >
                {t.cookies.policyLink}
              </Link>.
            </p>
            <div className="flex items-center gap-3 flex-wrap">
              <button
                data-testid="cookie-accept-all"
                onClick={handleAcceptAll}
                className="px-6 py-2.5 rounded-full bg-[#35589B] text-white text-sm font-light tracking-wider hover:bg-[#2C4A85] transition-colors duration-300"
              >
                {t.cookies.acceptAll}
              </button>
              <button
                data-testid="cookie-reject-all"
                onClick={handleRejectAll}
                className="px-6 py-2.5 rounded-full bg-[#35589B] text-white text-sm font-light tracking-wider hover:bg-[#2C4A85] transition-colors duration-300"
              >
                {t.cookies.rejectAll}
              </button>
            </div>
            <button
              data-testid="cookie-manage"
              onClick={() => setPrefsOpen(true)}
              className="text-sm font-light text-[#35589B] hover:underline transition-colors duration-300 text-left w-fit"
            >
              {t.cookies.manage}
            </button>
          </div>
        </div>
      )}
      <CookiePreferencesModal open={prefsOpen} onClose={handlePrefsClose} />
    </>
  );
}
